import questionnaire from './questionnaire';
import claimApplication from './claimApplication';
import feedback from './feedback';
import outBound from './outBound';
export default [...questionnaire, ...claimApplication,...feedback,...outBound];
